export const prefilledRenter = {
  address_1: '123 Main Street',
  address_2: '',
  birthdate: new Date(),
  city: 'Fayetteville',
  drivers_license: 'GA34343123',
  employer_address_1: '12 Oak Street',
  employer_address_2: '',
  employer_city: 'Fayetteville',
  employer_name: 'JC Penny',
  employer_phone: '404-393-3919',
  employer_state: 'GA',
  employer_zip: '30215',
  first_name: 'John',
  home_phone: '404-393-3919',
  last_name: 'Doe',
  middle_name: '',
  drivers_license_image: null,
  proof_of_income_image: null,
  proof_of_residence_image: null,
  references: [
    { email: 'john@jrewr.com', first_name: 'Justin', last_name: 'Appleseed', phone: '404-393-3919', relationship: 'mom'  },
    { email: 'john@jrewr.com', first_name: 'Justine', last_name: 'Appleseed', phone: '404-393-3919', relationship: 'dad'  },
  ],
  state: 'GA',
  zip: '30215',
};
